<script>
	import { format } from 'date-fns';
	import { daysRemaining, percentage } from '$lib/helpers';
	import { onMount } from 'svelte';
	import Image from './Image.svelte';
	import { favesStore } from '$stores/faves';
	import { browser } from '$app/environment';
	import { logError } from '$lib/helpers/errors';
	import ProgressBar from './ProgressBar.svelte';

	export let data;
	export let pid;
	export let isSingle = false;
	export let isListing = false;

	let heart = false;
	let startDate,
		endDate,
		featuredImage = '';
	let hasWinner = false;
	let qty = 1;

	$: cost = (data?.price * qty).toFixed(2);
	$: daysLeft = typeof data?.endDate === 'string' ? daysRemaining(data.endDate) : 0;
	$: endDateFormatted = data?.endDate;
	// $: showEndDateError = endDateFormatted === 'Unknown';
	// let endDateFormatted = '';
	onMount(() => {
		
		if (!browser) return;

		try {
			// Initialize start and end dates
			startDate = data?.createdAt ? format(new Date(data.createdAt), 'dd/MM/yyyy') : 'Unknown';
			// endDate = data?.endDate ? format(new Date(data.endDate), 'dd/MM/yyyy') : 'Unknown';

			endDateFormatted = new Date(data.endDate).toLocaleDateString();

			// Set featured image, fallback to placeholder if not available
			featuredImage =
				data?.featured_image || data?.item?.featured_image || '/images/placeholder-image.png';

			// Check if the product has a winner
			hasWinner = !!data?.winnerChosen;

			// Subscribe to favorites store to track the heart state
			const unsubscribe = favesStore.subscribe((value) => {
				heart = !value.includes(data?.id);
			});

			// Cleanup on component unmount
			return () => unsubscribe();
		} catch (error) {
			console.error('Error initializing ProductCardEnded:', error);
			logError(error, 'Error initializing ProductCardEnded');
		}
	});
</script>

<div class={isListing ? 'card listing-card' : 'card'}>
	{#if data && data?.name && data?.price && data?.featured_image}
		<article class={isSingle ? 'product-card single-card' : 'product-card'}>
			<div class="image">
				{#if isSingle}
					<Image threshold={0.2} src={data?.featured_image} alt={data?.name} />
				{:else}
					<a href={`/prizes/${pid}`} target="_self">
						{#if featuredImage}
							<Image threshold={0.2} src={data?.featured_image} alt={data.name} />
						{/if}
					</a>
				{/if}
			</div>

			<div class="product-card--wrap">
				<div class="title-wrap">
					{#if data.stock === 0}
						<p class="winner">Winner: <span>{data?.winnerName || 'Awaiting draw'}</span></p>
						{#if endDateFormatted}
						<p class="end-date">Ended: {endDateFormatted}</p>
						{/if}
					{:else}
						<p class="t-avail">Tickets Available: {data.stock}/{data.initStock}</p>
						<ProgressBar initialStock={data.initStock} currentStock={data.stock} />
					{/if}
				</div>

				<!-- {#if !showEndDateError}
					<div class="flex end-total">
						<div>
							<p class="days-left">
								{#if daysLeft === 0}
									<strong>9PM Tonight</strong>
								{:else if daysLeft === 1}
									<strong>Tomorrow</strong>
								{:else if daysLeft > 1}
									<strong>{daysLeft} Days</strong>
								{/if}
							</p>
							<p class="small-p">Ends {endDateFormatted}</p>
						</div>
						<div class="flex-end">
							<p class="total">£{cost}</p>
						</div>
					</div>
				{/if} -->
			</div>
		</article>
	{/if}
</div>

<style lang="scss">
	.red-banner {
		background-color: #fe1100;
		color: #fff;
		padding: 3px 6px;
		white-space: nowrap;
		font-weight: 700;
	}

	.small-p {
		font-size: 0.86em !important;
	}

	.btn-two {
		display: inline-block;
		margin-top: 20px;
	}

	.flex-end {
		display: flex;
		flex-direction: column;
		text-align: right;
	}

	article {
		position: relative;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
		transition: 0.3s;
		background-color: #fff;
		border-radius: 10px;
		min-width: 300px;
	}

	.sub-only {
		position: absolute;
		top: 0;
		left: 0;
		background-color: #fe1100;
		color: #fff;
		padding: 4px 8px;
		z-index: 10;
		border-radius: 0 0 10px 0;
		font-weight: 700;
		font-size: 0.8em;
	}

	.ind-ticket-cost {
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 10;
		background-color: #fff;
		width: 70px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 10px 0 0 0;
		padding-bottom: 10px;

		p {
			color: #fe1100;
			font-weight: bold;
			margin: 0;
			font-size: 1.2rem;
		}

		sup {
			display: block;
			margin-top: 4px;
		}
	}

	.highlight-card .total,
	.highlight-card .ind-ticket-cost p {
		color: goldenrod;
	}

	.product-card--wrap {
		padding: 6px;
	}

	.total {
		font-weight: 700;
		font-size: 22px;
		line-height: 25px;
		color: #fe1100;
		padding-left: 10px;

		@media (max-width: 469px) {
			padding-left: 0;
			margin-top: 12px;
		}
	}

	.card {
		padding: 10px;

		h2 {
			font-size: 1em;
			text-align: left;
			font-weight: 700;
			margin: 5px 0;
			min-height: 50px;
		}

		@media (min-width: 749px) {
			display: flex;
			align-items: stretch;
			max-width: 420px;
		}
	}

	.image {
		position: relative;
		overflow: hidden;
		text-align: center;
		min-height: 262px;
		min-width: 240px;
		border-radius: 6px 6px 0 0;
	}

	.end-total {
		display: flex;
		justify-content: space-between;
		margin-bottom: 12px;
		align-items: flex-start;

		&.upsell > div {
			min-height: 78px;
		}

		@media (max-width: 469px) {
			flex-direction: column;

			> div {
				width: 100%;
				justify-content: center;
				text-align: center;
			}

			.days-left {
				display: flex;
				justify-content: center;
				margin-bottom: 10px;

				img {
					margin-left: 10px;
				}
			}
		}
	}

	.winner {
		font-weight: 700;
		font-size: 1.2em;

		span {
			color: #fe1100;
		}
	}

	.end-date {
		font-size: 0.9em;
		font-weight: 600;
	}

	p {
		font-size: 0.95em;
		margin: 0;
	}

	.content {
		max-width: 420px;
		margin: auto;
	}

	strike {
		font-size: 0.8em;
		display: block;
	}

	.card.listing-card {
		padding: 5px;

		article {
			min-width: auto;

			.image {
				min-width: 120px;
				min-height: 120px;

				img {
					max-width: 100%;
				}
			}

			h2 {
				font-size: 0.85em;
			}

			p {
				font-size: 14px;
			}

			p.total {
				font-size: 16px;
			}
		}
	}

	.postal-btn {
		font-weight: 700;
		font-size: 18px;

		img {
			margin: 0px 0 -6px 8px;
			max-width: 30px;
			height: auto;
		}
	}

	.days-left {
		display: flex;
		align-items: center;
		white-space: nowrap;

		img {
			max-width: 30px;
			height: auto;
			margin-left: 4px;
		}
	}

	.prize-link {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
	}
</style>
